import { CashManagementRecord, CreateCashManagementRecord, GLCode, ICMBreakDownRecord, SaveBreakdownsFormData } from "../types/cash-management";
import { callApiInstance } from "./api";

class CashManagementService {
  private rootRoute: string;
  constructor() {
    this.rootRoute = "/CashManagement";
  }
  async getGLCodes(): Promise<GLCode[]> {
    return (await callApiInstance({ url: `${this.rootRoute}/getGLCodes` })).data;
  }
  async getCashManagementRecords(accounts: number | number[], startDate: string, endDate: string, searchTerm: string): Promise<CashManagementRecord[][]> {
    return (await callApiInstance({
      url: `${this.rootRoute}?ids=${Array.isArray(accounts) ? accounts.join(",") : accounts}&startDate=${startDate}&endDate=${endDate}&searchTerm=${searchTerm}`
    })).data;
  }
  async downloadCashManagementRecords(accounts: number | number[], startDate: string, endDate: string): Promise<any> {
    return (await callApiInstance({
      url: `${this.rootRoute}/excel?ids=${Array.isArray(accounts) ? accounts.join(",") : accounts
        }&startDate=${startDate}&endDate=${endDate}`,
      responseType: "arraybuffer"
    })).data;
  }
  async addRecord(data: CreateCashManagementRecord[]) {
    return (await callApiInstance({ url: `${this.rootRoute}`, method: "POST", data })).data;
  }
  async editRecord(data: Omit<CashManagementRecord, "balance" | "gl_code">[]) {
    return (await callApiInstance({ url: `${this.rootRoute}`, method: "PUT", data })).data;
  }
  async deleteRecord(id: string | number) {
    return (await callApiInstance({ url: `${this.rootRoute}?id=${id}`, method: "DELETE" })).data;
  }
  async getBreakdowns(id: string | number) {
    return (await callApiInstance({ url: `${this.rootRoute}/${id}/breakdowns`, method: "GET" }));
  }
  async createBreakdowns(data: ICMBreakDownRecord) {
    return (await callApiInstance({ url: `${this.rootRoute}/breakdowns`, method: "POST", data: [data] }));
  }
  async updateBreakdowns(data: ICMBreakDownRecord) {
    return (await callApiInstance({ url: `${this.rootRoute}/breakdowns/${data.ID}`, method: "PUT", data }));
  }
  async saveBreakdowns(data: SaveBreakdownsFormData) {
    return (await callApiInstance({ url: `${this.rootRoute}/breakdowns`, method: "POST", data }));
  }
  async deleteBreakdowns(id: string | number) {
    return (await callApiInstance({ url: `${this.rootRoute}/breakdown/${id}`, method: "DELETE", }));
  }
  async addUpdateBreakdowns(id: string | number, data: ICMBreakDownRecord[]) {
    return (await callApiInstance({ url: `${this.rootRoute}/${id}/breakdowns/`, method: "POST", data }));
  }
}
export const cashManagementService = new CashManagementService();
